import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
// X12 — les lots d'import Traxxall : la flotte, le lecteur et l'inspecteur ; jamais le client (I5).
export const MaintenanceImportRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet']}>
    <Route path='file/:batchId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
